// Version : 0.0.1
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : COMMENT LINES ADDED
// MODFIED DATA : 01-08-2025

import { docodeHexResponse } from '../../_common/common.utils';
import DealerActionTypes from './dealer.types';

const INITIAL_STATE = {
	// ADD DEALER RESPONSE
	addDealerDetailsResponse: null,
	// UPDATE DEALER RESPONSE
	updateDealerDetailsResponse: null,
	// GET DEALER LIST RESPONSE
	getDealerListResponse: null,
	getDealerListArr: [],
	// FETCH DEALER RESPONSE
	fetchDealerDetailsResponse: null,
	fetchDealerDetailsArr: [],
	// DELETE DEALER RESPONSE
	deleteDealerDetailsResponse: null,
	// DELETE DEALER STAFF RESPONSE
	deleteDealerStaffDetailsResponse: null,
	// APPROVE DEALER RESPONSE
	approveDealerDetailsResponse: null,
	};

const dealerReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD DEALER DETAILS START *********************** */
		case DealerActionTypes.ADD_DEALER_DETAILS_SUCCESS:
			return { ...state, addDealerDetailsResponse: action.payload };

		case DealerActionTypes.ADD_DEALER_DETAILS_FAILURE:
			return { ...state, addDealerDetailsResponse: action.payload };

		case DealerActionTypes.ADD_DEALER_DETAILS_RESPONSE_CHANGED:
			return { ...state, addDealerDetailsResponse: null };
		/** ***************** ADD DEALER DETAILS END *********************** */

		/** ***************** UPDATE DEALER DETAILS START *********************** */
		case DealerActionTypes.UPDATE_DEALER_DETAILS_SUCCESS:
			return { ...state, updateDealerDetailsResponse: action.payload };

		case DealerActionTypes.UPDATE_DEALER_DETAILS_FAILURE:
			return { ...state, updateDealerDetailsResponse: action.payload };

		case DealerActionTypes.UPDATE_DEALER_DETAILS_RESPONSE_CHANGED:
			return { ...state, updateDealerDetailsResponse: null };
		/** ***************** UPDATE DEALER DETAILS END *********************** */

		/** ***************** GET DEALER DETAILS START *********************** */
		case DealerActionTypes.GET_DEALER_LIST_SUCCESS:
			return {
				...state,
				getDealerListResponse: action.payload,
				getDealerListArr: docodeHexResponse(action.payload, 'FetchDealerListKey'),
			};
		case DealerActionTypes.GET_DEALER_LIST_FAILURE:
			return { ...state, getDealerListResponse: action.payload };

		case DealerActionTypes.GET_DEALER_LIST_RESPONSE_CHANGED:
			return { ...state, getDealerListResponse: null };
		/** ***************** GET DEALER DETAILS END *********************** */

		/** ***************** FETCH DEALER DETAILS START *********************** */
		case DealerActionTypes.FETCH_DEALER_DETAILS_SUCCESS:
			return {
				...state,
				fetchDealerDetailsResponse: action.payload,
				fetchDealerDetailsArr: docodeHexResponse(action.payload, 'GetParticularDealerKey'),
			};
		case DealerActionTypes.FETCH_DEALER_DETAILS_FAILURE:
			return { ...state, fetchDealerDetailsResponse: action.payload };

		case DealerActionTypes.FETCH_DEALER_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchDealerDetailsResponse: null };
		/** ***************** FETCH DEALER DETAILS END *********************** */

		/** ***************** DELETE DEALER DETAILS START *********************** */
		case DealerActionTypes.DELETE_DEALER_DETAILS_SUCCESS:
			return { ...state, deleteDealerDetailsResponse: action.payload };

		case DealerActionTypes.DELETE_DEALER_DETAILS_FAILURE:
			return { ...state, deleteDealerDetailsResponse: action.payload };

		case DealerActionTypes.DELETE_DEALER_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteDealerDetailsResponse: null };
		/** ***************** DELETE DEALER DETAILS END *********************** */

		/** ***************** DELETE DEALER STAFF DETAILS START *********************** */
		case DealerActionTypes.DELETE_DEALER_STAFF_DETAILS_SUCCESS:
			return { ...state, deleteDealerStaffDetailsResponse: action.payload };

		case DealerActionTypes.DELETE_DEALER_STAFF_DETAILS_FAILURE:
			return { ...state, deleteDealerStaffDetailsResponse: action.payload };

		case DealerActionTypes.DELETE_DEALER_STAFF_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteDealerStaffDetailsResponse: null };
		/** ***************** DELETE DEALER STAFF DETAILS END *********************** */

		/** ***************** APPROVE DEALER START *********************** */
		case DealerActionTypes.APPROVE_DEALER_SUCCESS:
			return { ...state, approveDealerDetailsResponse: action.payload };

		case DealerActionTypes.APPROVE_DEALER_FAILURE:
			return { ...state, approveDealerDetailsResponse: action.payload };

		case DealerActionTypes.APPROVE_DEALER_RESPONSE_CHANGED:
			return { ...state, approveDealerDetailsResponse: null };
		/** ***************** APPROVE DEALER END *********************** */

		default:
			return state;
	}
};
export default dealerReducer;
